import { FC } from 'react';
import { Box, CircularProgress } from '@mui/material';
import { useAppSelector } from '../../../main/hooks/hooks';
import { selectIsLoading, selectFullscreenLoading } from '../../../main/slices/utilSlice';

const LoadingIcon: FC = () => {
    const isLoading = useAppSelector(selectIsLoading);
    const isFullscreenLoading = useAppSelector(selectFullscreenLoading);
    if (!isLoading) return null;
    return (
        <Box sx={{
            position: isFullscreenLoading ? 'fixed' : 'absolute',
            inset: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backdropFilter: 'blur(2px)',
            zIndex: (theme) => theme.zIndex.modal + 1,
            pointerEvents: 'none',
        }}>
            <CircularProgress size={48} />
        </Box>
    );
};

export default LoadingIcon;
